// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__ere+a","edit":"styles_edit__f7IBD","popup":"styles_popup__kIqkX","option":"styles_option__1CGpb","icon":"styles_icon__dczCl"};